import RevolvingFundsError from './RevolvingFundsError';
class RevolvingFundsInvalidQueryParam extends RevolvingFundsError {
    constructor(queryParams, options) {
        const entries = Object.entries(queryParams);
        const message = `The following query parameters are invalid: ${entries.map(([key, value]) => `['${key}': ${value}]`).join(', ')}`;
        super(message, options);
    }
}
export default RevolvingFundsInvalidQueryParam;
